export default function FomoPage() {
  return <div>FOMO! If you want to react to your friend's content, open this link in Chrome, Safari or Brave</div>;
}
